import React, { useEffect, useState, CSSProperties } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/Computation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labg from "./images/iconsb/labb.png"
import HashLoader from "react-spinners/HashLoader";
import dogo from './images/agroCHEM.gif';
import labService from './labService';



const Computation = ({ isCollapsed, toggleSidebar }) => {
    const navigate = useNavigate();
    const { pk } = useParams(); // Get the `pk` from the URL parameters
    const [redirectUrl, setRedirectUrl] = useState(null);

    const goToLab = () => {
        navigate('/laboratory');
    };

    useEffect(() => {
        const checkComputationStatus = async () => {
            try {
                const response = await labService.checkComputationStatus(pk);
                if (response.data.redirect_url) {
                    // If computation is done, redirect to result page
                    navigate(response.data.redirect_url);
                }
            } catch (error) {
                console.error("Error fetching computation status:", error);
            }
        };

        // Poll every 10 seconds
        const intervalId = setInterval(checkComputationStatus, 10000);

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, [pk, navigate]);


    // useEffect(() => {
    //     // Construct the WebSocket URL
    //     const wsUrl = `ws://127.0.0.1:8000/ws/compnew/${pk}/`;
    //     const socket = new WebSocket(wsUrl);

    //     // Handle incoming messages
    //     socket.onmessage = (event) => {
    //         const data = JSON.parse(event.data);
    //         if (data.redirect_url) {
    //             setRedirectUrl(data.redirect_url);
    //         }
    //     };

    //     // Clean up WebSocket connection on component unmount
    //     return () => {
    //         socket.close();
    //     };
    // }, [pk]); // Dependency array includes `pk` so it reconnects if `pk` changes

    // useEffect(() => {
    //     if (redirectUrl) {
    //         window.location.href = redirectUrl;
    //     }
    // }, [redirectUrl]);
    

    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={goToLab} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps comp-tab-1'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps comp-tab-2'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps comp-tab-3'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps comp-tab-4'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                    </div>
                    <div className='np-content'>
                        <div className='loading-comp'>
                            <HashLoader
                            className='loader'
                            size={120}
                            color='#0b5578'
                            />
                            {/* <img className='loader dogo' src={dogo} alt="My Local GIF" /> */}
                            <div className='load-div'>
                                <p className='comp-run'>Computation running...</p>
                                <p className='you-can-go'>You can go to the</p>
                                <button onClick={goToLab} className='lab-load'><img className="lab-load-icon" src={labg} alt="laboratory" />Laboratory</button>
                                <p>and wait for the results.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
      
};

export default Computation;